import { render, staticRenderFns } from "./Withdrawbay.vue?vue&type=template&id=0fdee400"
import script from "./Withdrawbay.vue?vue&type=script&lang=js"
export * from "./Withdrawbay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports